// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import NProgress from 'nprogress'
import Dashboard from './views/dashboard/layout'
import dashboardLogin from './views/dashboard/login/layout'
import Default from './views/website/layout'
import '../node_modules/nprogress/nprogress.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export

import { loadLanguageAsync } from '@/plugins/i18n' // path to vuetify export
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.$cookies.config('7d')
Vue.use(VueAxios, axios)


const buildURL = 'https://api.prime-shipping.net/prime/api/dashboard'

const baseURL =  'http://localhost:5000/prime/api/dashboard'

if (typeof baseURL !== 'undefined' && typeof buildURL !== 'undefined') {
  if(process.env.NODE_ENV === 'production'){
    Vue.axios.defaults.baseURL = buildURL
    Vue.prototype.$baseURL = 'https://api.prime-shipping.net/'
  }else{
    Vue.axios.defaults.baseURL = baseURL
    Vue.prototype.$baseURL = 'http://localhost:5000/'
    
  }
}

Vue.prototype.$permissions = {value: null}
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).startOf('day').format('DD/MM/YYYY')
    }
});

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});

axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
axios.defaults.headers.common['AuthorizationCustomer'] = `PrimeCustomerLogging ${store.state.customerToken}`;

Vue.config.productionTip = false

Vue.component('dashboard-layout', Dashboard)
Vue.component('default-layout', Default)
Vue.component('dashboard-login-layout', dashboardLogin)

router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})

router.beforeEach((to, from, next) => {
  if(from.name === null){
    Vue.prototype.$loader = true
  }
  if(!Vue.$cookies.get('lang')){
    Vue.$cookies.set('lang', 'en')
  }
  loadLanguageAsync(Vue.$cookies.get('lang')).then(() => {})
  document.title = "Prime Shipping Agency"
  /*if(process.env.NODE_ENV === 'production'){
    if(to.name === 'comingSoon'){
      next()
    }else{
      if(to.fullPath.indexOf('dashboard') === -1 || from.name === 'comingSoon'){
        next({
          name: 'comingSoon'
        })
        return
      }
    } 
  }*/
  if(from.name === 'websiteSettings' && to.fullPath.indexOf('dashboard') === -1){
    next({name : from.name})
    return
  }

  if(store.getters.getCustomer){
    axios
        .get('../customer/checkAuthentification')
        .then(response => {
          if (response.data.result !== true) {
            store.dispatch('logoutCustomer')
            location.reload()
            next()
          }else {
            next()
          }  
        })
  }

  if (!to.meta.allowAnonymous) {
    if(to.fullPath.indexOf('customer/dashboard') !== -1){
      axios
        .get('../customer/checkAuthentification')
        .then(response => {
          if (response.data.result !== true) {
            next({
              name: 'loginCustomer',
              query: { redirect: to.fullPath }
            })
          }else {
            if(from.name !== to.name){
              window.scrollTo(0, 0)
            }
            next()
          }  
        })
        .catch(e => {
          console.log(e)
          next({
            name: 'loginCustomer',
            query: { redirect: to.fullPath }
          })
        })
    }else{
      axios
        .get('/checkAuthentification')
        .then(response => {
          if (response.data.result !== true) {
            next({
              name: 'dashboardLogin',
              query: { redirect: to.fullPath }
            })
          }else {
            if(store.getters.getUser !== ''){
              axios
                .get('getPermissionByCredentials/'+store.getters.getUser)
                .then( response => {
                  if(to.meta.permissions.length > 0){
                    let verif = true
                    to.meta.permissions.forEach((perm, key) => {
                      if(response.data.data.indexOf(perm) === -1){
                        verif = false
                      }
                    })
                    if(verif !== true){
                      next({
                        name: 'notAllowed'
                      })
                    }else{
                      next()
                    }
                  }
                })
            }
            

            if(from.name !== to.name){
              window.scrollTo(0, 0)
            }
            next()
          }  
        })
        .catch(e => {
          console.log(e)
          next({
            name: 'dashboardLogin',
            query: { redirect: to.fullPath }
          })
        })
    }
  }
  else {
    if(from.name !== to.name){
      window.scrollTo(0, 0)
    }
    next()
  }  
  
  
})


router.afterEach((to, from) => {
  NProgress.done()
})

new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js